var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"elevation-4 mb-4",attrs:{"width":"100%"}},[_c('div',{style:(_vm.ui.chartMaxHeight)},[_c('canvas',{attrs:{"id":_vm.chartName}})]),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"text-h5 mb0"},[_vm._v(_vm._s(_vm.name))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }